import * as bootstrap from 'bootstrap';
import { TTBackboneView } from '@/views/TTBackboneView';
import { TTAPI } from '@/services/TimeTrexClientAPI';
import { IndexViewController} from '@/portal/recruitment/IndexController'; // For the reference in the html file PortalJobVacancyView.html loaded from this file.
import { PortalJobVacancyRowController } from '@/views/portal/hr/recruitment/PortalJobVacancyRowController';

export class PortalBaseViewController extends TTBackboneView {
	constructor( options = {} ) {
		_.defaults( options, {
			can_cache_controller: true, //if allow to cache current controller
			pager_data: null,
			// required_files: [],

			events: {
				'click .search-btn': 'onSearchClick',
				'change select[id="country"]': 'onCountryChange',
				// 'click .more': 'loadMore'
				// 'click .styled-select .glyphicon': 'onSelectClick',
				'keydown input[id="name"]': 'autoSearch',
				// 'change select[id="province"]': 'onSearchClick',
				'keydown input[id="city"]': 'autoSearch'
			}
		} );

		super( options );
	}

	initialize( options ) {
		window.bootstrap = bootstrap;
		this.installSelectPickerKeyboardGuard();
		super.initialize( options );

		this.preInit( options );

		// __non_webpack_require__( this.getRequiredFiles(), function() {
		this.company_api = TTAPI.APICompanyPortal;
		LocalCacheData.current_open_primary_controller = this;
		this.init();
		this.postInit( options );
		// } );
	}

	// getRequiredFiles() {
	// 	//override in child class
	// 	return this.required_files.concat( this._required_files );
	// }

	preInit() {
		//Override in child class.
		return;
	}

	init() {
		//Override in child class.
		return;
	}

	postInit() {
		//Override in child class.
		return;
	}

	// Refresh bootstrap-select after native option changes so keyboard navigation uses current menu data.
	refreshSelectPicker( field_control, selected_value ) {
		if ( !field_control || !field_control[0] ) {
			return;
		}

		if ( field_control.data( 'selectpicker' ) ) {
			field_control.selectpicker( 'refresh' );
		} else {
			field_control.selectpicker();
		}

		if ( arguments.length > 1 ) {
			if ( selected_value === false || selected_value === null || typeof selected_value === 'undefined' ) {
				field_control.selectpicker( 'val', '' );
			} else {
				field_control.selectpicker( 'val', selected_value );
			}
		}
	}

	// Capture selectpicker arrow/escape keys before Bootstrap's delegated dropdown handler sees them.
	installSelectPickerKeyboardGuard() {
		if ( PortalBaseViewController.selectpicker_keyboard_guard_installed === true ) {
			return;
		}

		if ( !$.fn.selectpicker || !$.fn.selectpicker.Constructor ) {
			return;
		}

		var $this = this;
		var keydown_handler = $.fn.selectpicker.Constructor.prototype.keydown;
		var arrow_keys = [38, 40];
		var selection_keys = [13, 32];

		document.addEventListener( 'keydown', function( e ) {
			var key_code = e.which || e.keyCode;
			var select_picker = e.target && e.target.closest ? e.target.closest( '.bootstrap-select' ) : null;
			if ( !select_picker ) {
				return;
			}

			var select_picker_instance = $( select_picker ).data( 'this' );
			if ( !select_picker_instance ) {
				return;
			}

			var is_menu_open = select_picker_instance.$menu.hasClass( 'show' );
			var should_select_on_tab = select_picker_instance.options.selectOnTab === true;

			if ( key_code === 9 && is_menu_open === true && should_select_on_tab !== true ) {
				e.preventDefault();
				e.stopImmediatePropagation();

				setTimeout( function() {
					$this.hideSelectPickerMenu( select_picker_instance );
					$this.focusAdjacentTabStop( select_picker_instance.$button[0], e.shiftKey === true );
				}, 0 );
				return;
			}

			if ( key_code === 27 && is_menu_open === true ) {
				e.preventDefault();
				e.stopImmediatePropagation();

				$this.hideSelectPickerMenu( select_picker_instance );
				if ( select_picker_instance.$button && select_picker_instance.$button[0] ) {
					select_picker_instance.$button[0].focus();
				}
				return;
			}

			var should_intercept = arrow_keys.indexOf( key_code ) !== -1 ||
				( is_menu_open && selection_keys.indexOf( key_code ) !== -1 ) ||
				( is_menu_open && key_code === 9 && should_select_on_tab === true );

			if ( should_intercept !== true ) {
				return;
			}

			var handler_target = e.target.closest( '[data-bs-toggle="dropdown"], [role="listbox"], .bs-searchbox input' );
			if ( !handler_target || select_picker.contains( handler_target ) !== true ) {
				return;
			}

			keydown_handler.call( handler_target, e );
			e.stopImmediatePropagation();

			var should_close_after_selection = is_menu_open &&
				select_picker_instance.multiple !== true &&
				(
					key_code === 13 ||
					( key_code === 9 && should_select_on_tab === true ) ||
					( key_code === 32 &&
						select_picker_instance.options.liveSearch !== true &&
						select_picker_instance.selectpicker.keydown.keyHistory === '' )
				);

			if ( should_close_after_selection ) {
				setTimeout( function() {
					$this.hideSelectPickerMenu( select_picker_instance );
					if ( key_code === 9 ) {
						$this.focusAdjacentTabStop( select_picker_instance.$button[0], e.shiftKey === true );
					} else if ( select_picker_instance.$button && select_picker_instance.$button[0] ) {
						select_picker_instance.$button[0].focus();
					}
				}, 0 );
			}
		}, true );

		PortalBaseViewController.selectpicker_keyboard_guard_installed = true;
	}

	// Move focus to the next or previous tabbable field outside the selectpicker menu after keyboard selection.
	focusAdjacentTabStop( current_element, reverse ) {
		if ( !current_element || !current_element.ownerDocument ) {
			return;
		}

		var focusable_selector = 'a[href], button, input, select, textarea, [tabindex]';
		var focusable_elements = $( current_element.ownerDocument ).find( focusable_selector ).filter( function() {
			var $element = $( this );
			var tab_index = $element.attr( 'tabindex' );

			return $element.is( ':visible' ) &&
				this.disabled !== true &&
				( tab_index === undefined || parseInt( tab_index, 10 ) >= 0 ) &&
				$element.closest( '.bootstrap-select .dropdown-menu' ).length === 0;
		} );
		var current_index = focusable_elements.index( current_element );

		if ( current_index === -1 ) {
			return;
		}

		var target_index = reverse === true ? current_index - 1 : current_index + 1;
		var next_element = focusable_elements.get( target_index );

		if ( next_element && typeof next_element.focus === 'function' ) {
			next_element.focus();
		}
	}

	hideSelectPickerMenu( select_picker_instance ) {
		if ( !select_picker_instance || !select_picker_instance.$button || !select_picker_instance.$button[0] ) {
			return;
		}

		if ( window.bootstrap && window.bootstrap.Dropdown && typeof window.bootstrap.Dropdown.getOrCreateInstance === 'function' ) {
			window.bootstrap.Dropdown.getOrCreateInstance( select_picker_instance.$button[0] ).hide();
		} else if ( typeof select_picker_instance.close === 'function' ) {
			select_picker_instance.close();
		}
	}

	render() {
		var $this = this;
		ProgressBar.showOverlay();
		this.initOptions( function() {
			$this.search();
		} );

		$( window ).off( 'scroll' ).on( 'scroll', Global.debounce( function() {
			if ( $this.isOnScreen( '.more.container' ) ) {
				$this.loadMore();
			}
		}, 200 ) );
	}

	isOnScreen( element_id ) {
		let element = $( element_id );

		if ( element.length === 0 || !element.is( ':visible' ) ) {
			return false;
		}

		let bounding = element[0].getBoundingClientRect();

		if ( bounding.top >= 0 && bounding.left >= 0 && bounding.right <= ( window.innerWidth || document.documentElement.clientWidth ) && bounding.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) ) {
			return true;
		} else {
			return false;
		}
	}

	autoSearch( e ) {
		if ( e.keyCode === 13 ) {
			this.onSearchClick();
		}
	}

	initOptions( callback ) {
		this.initCountryOptions( callback );
	}

	initCountryOptions( callback ) {
		var $this = this;
		this.company_api.getOptions( 'country', {
			onResult: function( result ) {
				var result = result.getResult();
				$this.$( '#country' ).append( $( '<option></option>' ).prop( 'value', '' ).attr( 'selected', 'selected' ).text( $.i18n._( 'All Countries' ) ) );
				$.each( result, function( value, label ) {
					$this.$( '#country' ).append( $( '<option></option>' ).prop( 'value', value ).text( $.i18n._( label ) ) );
				} );
				$this.refreshSelectPicker( $this.$( '#country' ) );
				$this.refreshSelectPicker( $this.$( '#province' ) );
				callback();
			}
		} );
	}

	onCountryChange() {
		this.eSetProvince( this.$( 'select[id="country"]' ).val() );
	}

	eSetProvince( val ) {
		var $this = this;
		$this.$( '#province' ).selectpicker( 'destroy' );
		if ( !val ) {
			$this.$( '#province' ).html( $( '<option></option>' ).prop( 'value', '' ).attr( 'selected', 'selected' ).text( $.i18n._( 'All Province/States' ) ) );
			$this.refreshSelectPicker( $this.$( '#province' ) );
			return;
		}
		this.company_api.getOptions( 'province', val, {
			onResult: function( result ) {
				result = result.getResult();
				if ( !result ) {
					result = [];
				}
				$this.$( '#province' ).html( $( '<option></option>' ).prop( 'value', '' ).attr( 'selected', 'selected' ).text( $.i18n._( 'All Province/States' ) ) );
				$.each( result, function( value, label ) {
					$this.$( '#province' ).append( $( '<option></option>' ).prop( 'value', value ).text( $.i18n._( label ) ) );
				} );
				$this.refreshSelectPicker( $this.$( '#province' ) );
			}
		} );
	}

	loadMore() {
		this.onSearchClick( {
			page_action: 'next'
		} );
	}

	addSearchResultPanel() {
	}

	onSearchClick( options ) {
		var $this = this;
		var filter = {};
		this.addSearchResultPanel();
		// first load
		if ( typeof options == 'undefined' ) {
			options = {};
		}
		this.vacancy_list_panel = this.$( '.search-result .content' );
		this.more_btn = this.$( '.search-result .more' );
		this.more_btn.unbind( 'click' ).bind( 'click', function() {
			$this.loadMore();
		} );
		filter.filter_data = {};
		filter.filter_sort = {};
		filter.filter_items_per_page = 0; // Default to 0 to load user preference defined
		// if ( this.$('#job_title_id').val() && parseInt( this.$('#job_title_id').val() ) > 0  ) {
		// 	filter.filter_data['title_id'] = this.$('#job_title_id').val();
		// }
		if ( this.$( '#name' ).val() && this.$( '#name' ).val() != '' ) {
			filter.filter_data['name'] = this.$( '#name' ).val();
		}
		if ( this.$( '#country' ).val() && this.$( '#country' ).val() != '' ) {
			filter.filter_data['country'] = this.$( '#country' ).val();
		}
		if ( this.$( '#province' ).val() && this.$( '#province' ).val() != '' ) {
			filter.filter_data['province'] = this.$( '#province' ).val();
		}
		if ( this.$( '#city' ).val() && this.$( '#city' ).val() != '' ) {
			filter.filter_data['city'] = this.$( '#city' ).val();
		}
		if ( this.pager_data ) {
			if ( options.page_action === 'next' ) {
				filter.filter_page = this.pager_data.next_page;
			} else {
				filter.filter_page = 1;
			}
		} else {
			filter.filter_page = 1;
		}

		//If branch_id is specified on the URL, pass that into the filter here as well.
		if ( LocalCacheData.getAllURLArgs() && LocalCacheData.getAllURLArgs().hasOwnProperty( 'branch_id' ) ) {
			filter.filter_data['branch_id'] = LocalCacheData.getAllURLArgs().branch_id;
		}

		this.api['get' + this.api.key_name]( filter, false, { // paging or none
			onResult: function( result ) {
				$this.pager_data = result.getPagerData();
				var result_data = result.getResult();
				var no_result_panel = $this.vacancy_list_panel.find( '.vacancy-list-no-result' );
				var result_panel = $( '<div></div>' );
				if ( !Global.isArray( result_data ) ) {
					var no_result_span = $( '<div class="vacancy-list-no-result">' + $.i18n._( 'No Results Found' ) + '</div>' );
					result_panel.append( no_result_span );
				} else {
					for ( var i = 0; i < result_data.length; i++ ) {
						var row = result_data[i];
						var vacancy_model = new Backbone.Model( row );
						var vacancy_row = new PortalJobVacancyRowController( { model: vacancy_model } );
						result_panel.append( vacancy_row.el );
					}
				}

				if ( options.page_action !== 'next' || no_result_panel[0] || ( $this.pager_data && $this.pager_data.is_first_page ) ) {
					$this.vacancy_list_panel.empty().append( result_panel.children() );
				} else {
					$this.vacancy_list_panel.append( result_panel.children() );
				}

				if ( !$this.pager_data || $this.pager_data.is_last_page || result_data === true ) {
					$this.more_btn.hide();
				} else {
					$this.more_btn.show();
				}
				if ( typeof options.callback != 'undefined' ) {
					options.callback();
				}
			},
			onError: function () {
				//Issue #3083 - This search call is being aborted which will result in a blank page if the user quickly goes to "My Profile" and logs out immediately.
				//In addition, the async calls are being aborted, so we cannot call search again as all future calls are also aborted.
				//This is a rare enough scenario that we have opted to do a reload in this specific case.
				window.location.reload();
			}
		} );
	}

	onSelectClick( e ) {
		var elem = $( e.currentTarget ).parent().find( 'select' );
		if ( document.createEvent ) {
			var e = document.createEvent( 'MouseEvents' );
			e.initMouseEvent( 'mousedown', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null );
			elem[0].dispatchEvent( e );
		} else if ( element.fireEvent ) {
			elem[0].fireEvent( 'onmousedown' );
		}
	}
}

PortalBaseViewController.selectpicker_keyboard_guard_installed = false;

PortalBaseViewController.shouldUseRouteTransitionSnapshot = function( view_id ) {
	var current_view_id = LocalCacheData.current_open_view_id;

	return ( current_view_id === 'PortalJobVacancy' && view_id === 'PortalJobVacancyDetail' )
			|| ( current_view_id === 'PortalJobVacancyDetail' && view_id === 'PortalJobVacancy' )
			|| ( current_view_id && current_view_id !== view_id && ( current_view_id === 'MyProfile' || view_id === 'MyProfile' ) );
};

PortalBaseViewController.createRouteTransitionSnapshot = function() {
	var content_container = Global.contentContainer();
	if ( !content_container || content_container.children().length == 0 ) {
		return null;
	}

	var rect = content_container[0].getBoundingClientRect();
	if ( rect.width <= 0 || rect.height <= 0 ) {
		return null;
	}

	var snapshot = $( '<div class="portal-route-transition-snapshot"></div>' );
	var snapshot_content = content_container.children().clone( false ).not( 'script' );
	snapshot_content.find( 'script' ).remove();
	snapshot.append( snapshot_content );
	snapshot.css( {
		top: rect.top,
		left: rect.left,
		width: rect.width,
		height: rect.height
	} );
	$( 'body' ).append( snapshot );

	return snapshot;
};

PortalBaseViewController.getRouteTransitionReadySelector = function( view_id ) {
	switch ( view_id ) {
		case 'PortalJobVacancy':
			return '#job_vacancy_view_container .search-result .content .row-vacancy, #job_vacancy_view_container .search-result .content .vacancy-list-no-result';
		case 'PortalJobVacancyDetail':
			return '.job-vacancy-detail-view .job_vacancy_detail_view_container';
		case 'MyProfile':
			return '#my_profile_view .job-applicant-detail';
	}

	return null;
};

PortalBaseViewController.removeRouteTransitionSnapshotWhenReady = function( view_id, snapshot ) {
	if ( !snapshot || snapshot.length == 0 ) {
		return;
	}

	var ready_selector = PortalBaseViewController.getRouteTransitionReadySelector( view_id );
	var attempts = 0;
	var max_attempts = view_id === 'MyProfile' ? 200 : 80;

	function removeSnapshot() {
		snapshot.addClass( 'portal-route-transition-snapshot-fade' );
		setTimeout( function() {
			snapshot.remove();
		}, 150 );
	}

	function waitForReadyView() {
		attempts++;
		if ( ready_selector == null || $( ready_selector ).length > 0 || attempts >= max_attempts ) {
			removeSnapshot();
			return;
		}

		setTimeout( waitForReadyView, 50 );
	}

	waitForReadyView();
};

PortalBaseViewController.loadView = function( view_id ) {
	var route_transition_snapshot = null;
	if ( PortalBaseViewController.shouldUseRouteTransitionSnapshot( view_id ) ) {
		route_transition_snapshot = PortalBaseViewController.createRouteTransitionSnapshot();
	}

	Global.loadViewSource( view_id, view_id + 'View.html', function( result ) {
		var template = _.template( result )();
		window.IndexViewController = IndexViewController; // // For the reference in the html file PortalJobVacancyView.html loaded from this file.
		Global.contentContainer().html( template );

		LocalCacheData.current_open_view_id = view_id;

		$( 'div.tooltip' ).remove(); //Issue #2676 - Removing tooltips on page load to prevent validation errors from lingering on screen.

		Global.trackView( view_id, LocalCacheData.current_doing_context_action );

		PortalBaseViewController.removeRouteTransitionSnapshotWhenReady( view_id, route_transition_snapshot );
	} );

};
